module.exports = {
      id: "icon-audio-fb-usage",
      viewBox: "0 0 25.21 25.21",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-audio-fb",
      toString: function () {
        return this.url;
      }
    }